import {RestQueryParams} from "educat-common-web";
import { Observable } from "rxjs";
import {educatAPI} from "./provider/educatAPI";

export function confirmMentorOnboardingAPI(authToken: string, mentorId: string, payload: any): Observable<any> {
  return educatAPI.put(
    `mentors/${mentorId}/confirm`,
    payload,
    new RestQueryParams(),
    {
      Authorization: `Bearer ${authToken}`,
    }
  );
}
